export default "__VITE_ASSET__CWQDkiPE__"